import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import strings from 'strings';

import { useAssistantActionsStyles } from './AssistantActions.styled';

export const AssistantActions = ({ onClickNewChat, onClickSearch }) => {
  const classes = useAssistantActionsStyles();

  return (
    <Box p={1} pb={0} display="flex" flexDirection="column" alignItems="stretch">
      <Button
        className={classes.newChatButton}
        startIcon={<AddIcon />}
        fullWidth
        color="primary"
        onClick={onClickNewChat}
      >
        {strings.ai.generators.assistant.sidebar.newChat}
      </Button>

      <Button
        className={classes.searchButton}
        startIcon={<SearchIcon />}
        fullWidth
        color="primary"
        onClick={onClickSearch}
      >
        {strings.ai.generators.assistant.sidebar.searchChat}
      </Button>
    </Box>
  );
};
